import type { Annotation, SelectedAnnotation } from './types';

export const mapAnnotationForGeneration = (annotation: Annotation) => ({
  type: annotation.type,
  content: annotation.content || annotation.text,
});

export const isSameMappedAnnotation = (first: SelectedAnnotation, second: SelectedAnnotation) => {
  return first.content === second.content && first.accountId === second.accountId;
};
